// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#AdminUserEdit .input-row-area {
  width: 100%;
}
#AdminUserEdit .input-label-text {
  text-align: left;
}
#AdminUserEdit .update-button {
  max-width: 10%;
}
#AdminUserEdit .expand-button {
  border-radius: 14px;
  font-size: var(--text-size-normal);
  margin: 16px auto;
  max-width: 200px;
  min-height: 28px;
  padding: 0px;
}
#AdminUserEdit .file-display-area {
  border: solid 1px var(--border-weak-color);
  padding: 32px;
}
#AdminUserEdit .operate-area {
  width: 50%;
}
#AdminUserEdit .operate-button {
  width: 180px;
  padding: 8px 4px;
  min-height: 28px;
  max-height: 28px;
  min-width: 72px;
  border-radius: 14px;
  border: 1px solid var(--border-weak-color);
  background-color: var(--white-color-lightest);
  transition: background-color 0.3s color 0.3s border 0.3s;
}
#AdminUserEdit .operate-button:hover {
  background-color: var(--dark-color-main);
  color: var(--white-color-main);
}
#AdminUserEdit .operate-button.danger:hover {
  background-color: var(--danger-color-main);
  border: 1px solid var(--danger-color-main);
  color: var(--white-color-lightest);
}
#AdminUserEdit .operate-button.primary {
  background-color: var(--primary-color-main);
  border: 1px solid var(--primary-color-main);
  color: var(--white-color-lightest);
}
#AdminUserEdit .operate-button.primary:hover {
  background-color: var(--primary-color-dark);
  color: var(--white-color-lightest);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/AdminUserEdit.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AAEI;EACI,gBAAA;AAAR;AAEI;EACE,cAAA;AAAN;AAGI;EACI,mBAAA;EACA,kCAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AADR;AAII;EACE,0CAAA;EACA,aAAA;AAFN;AAKI;EACE,UAAA;AAHN;AAMI;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EAEA,0CAAA;EACA,6CAAA;EACA,wDAAA;AALR;AAOQ;EACI,wCAAA;EACA,8BAAA;AALZ;AASY;EACI,0CAAA;EACA,0CAAA;EACA,kCAAA;AAPhB;AAUQ;EACI,2CAAA;EACA,2CAAA;EACA,kCAAA;AARZ;AAUY;EACI,2CAAA;EACA,kCAAA;AARhB","sourcesContent":["#AdminUserEdit{\r\n    .input-row-area{\r\n        width: 100%;\r\n      }\r\n    .input-label-text{\r\n        text-align: left;\r\n      }\r\n    .update-button{\r\n      max-width: 10%\r\n    }\r\n\r\n    .expand-button {\r\n        border-radius: 14px;\r\n        font-size: var(--text-size-normal);\r\n        margin: 16px auto;\r\n        max-width: 200px;\r\n        min-height: 28px;\r\n        padding: 0px;\r\n    }\r\n\r\n    .file-display-area{\r\n      border: solid 1px var(--border-weak-color);\r\n      padding: 32px;\r\n    }\r\n\r\n    .operate-area{\r\n      width: 50%;\r\n    }\r\n\r\n    .operate-button{\r\n        width: 180px;\r\n        padding: 8px 4px;\r\n        min-height: 28px;\r\n        max-height: 28px;\r\n        min-width: 72px;\r\n        border-radius: 14px;\r\n\r\n        border: 1px solid var(--border-weak-color);\r\n        background-color: var(--white-color-lightest);\r\n        transition: background-color 0.3s color 0.3s border 0.3s;\r\n\r\n        &:hover{\r\n            background-color: var(--dark-color-main);\r\n            color: var(--white-color-main);\r\n        }\r\n\r\n        &.danger{\r\n            &:hover{\r\n                background-color: var(--danger-color-main);\r\n                border: 1px solid var(--danger-color-main);\r\n                color: var(--white-color-lightest);\r\n            }\r\n        }\r\n        &.primary{\r\n            background-color: var(--primary-color-main);\r\n            border: 1px solid var(--primary-color-main);\r\n            color: var(--white-color-lightest);\r\n\r\n            &:hover{\r\n                background-color: var(--primary-color-dark);\r\n                color: var(--white-color-lightest);\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
